module.exports = __webpack_public_path__ + "img/macellan-logo.0fd43d90.svg";